var map = {
	"./1-support-for-new-language-features.webp": 476,
	"./2-new-inspections.webp": 83,
	"./3-overloads-in-quick-documentation.webp": 452,
	"./4-inlay-hints.gif": 910,
	"./5-quick-fix.gif": 972,
	"./6-improved-autocompletion.gif": 750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;